import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-254e7abb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "booking-controls -mb-2 mr-2" }
const _hoisted_2 = { class: "field inline-block legend-area ml-2" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "text-sm font-medium absolute top-0 pt-1 time" }
const _hoisted_6 = {
  key: 0,
  class: "text-xs pb-1"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/warning-logo.png",
    alt: "Warning Logo",
    class: "warning-logo mr-4 ml-2"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "警告")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid mt-5 mb-5 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "予約の変更をお客様へ通知しますか？")
], -1))
const _hoisted_9 = { class: "my-5 flex justify-content-center" }

import {
  computed,
  ref,
  withDefaults,
  onBeforeMount,
  onMounted,
  inject,
  watch,
  nextTick,
} from "vue";
import { useStore } from "vuex";
import { get, set, templateRef, useDateFormat } from "@vueuse/core";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import FullCalendar from "@fullcalendar/vue3";
import interactionPlugin from "@fullcalendar/interaction";
import { CalendarOption } from "echarts/types/dist/shared";
import { DateSelectArg, EventChangeArg, EventContentArg, EventSourceFuncArg } from "@fullcalendar/core";
import _ from "lodash";
import moment from "moment";
import Header from "../header.vue";
import DayEvent from "../template/events/day.vue";
import ToolTipEvent from "../template/events/tooltip.vue";
import TimeUtils from "@/clinic/utils/time-utils";
import DayOfWeek from "@/clinic/utils/day-of-week-utils";
import { ToastServiceMethods } from "primevue/toastservice";
import { notifySuccessMsg, notityErrorMsg } from "@/clinic/utils/notify-utils";
import { BookingServices, ClinicBusinessDaySettingService, RoomServices } from "@/clinic/services";
import {
  ApiBookingIndexReq,
  ApiBookingSaveReq,
  IBooking,
  IBookingEventInput,
  IBookingEventInputExtendedProps,
  IBookingPickedTime,
} from "@/clinic/typings";
import {
  BookingViewTypeEnum,
  BookingStatusColorClass,
  BookingSourceColorClasses,
  BookingStatusColorOptions,
  BookingActionEnum,
  BookingStatusFull,
} from "@/clinic/typings/enums/booking";
import {
  MILLISECONDS_IN_DAY,
  MILLISECONDS_MIN_SLOT_DEFAULT,
  MILLISECONDS_MAX_SLOT_DEFAULT,
} from "@/clinic/typings/constants/booking";
import { ClinicPartner } from "@/clinic/typings/enums/clinic";
type IBodyCalendar = {
  slotDuration: string;
  toast: ToastServiceMethods;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    slotDuration: { default: "" },
    toast: null
  },
  emits: ["showBookingSideBar"],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { slotDuration: string, toast: ToastServiceMethods };


const store = useStore();


const roomBookingCalendar = templateRef<InstanceType<typeof FullCalendar>>("roomBookingCalendar", null);
const setClinicId = async () => set(clinicId, await inject("clinicId"));
const clinicId = ref(0);
const clinicDaySetting = ref();
const remainingSlots = ref([]);
const rooms = ref([]);
const term = ref("");
const status = ref(BookingStatusFull);
const pickedDate = ref<IBookingPickedTime>({
  start: moment().toDate(),
  end: moment().toDate(),
});
const currentEvent = ref();
const previousEvent = ref();
const currentResource = ref();
const previousResource = ref();
const showUpdateEventConfirmDialog = ref(false);
const undoAction = ref();

const startDate = computed(() => moment(get(pickedDate).start).format("YYYY-MM-DD"));
const endDate = computed(() => moment(get(pickedDate).end).format("YYYY-MM-DD"));
const slotMintime = computed(() => ({ millisecond: slotMinTimeMilliseconds() }));
const slotMaxTime = computed(() => ({ millisecond: slotMaxTimeMilliseconds() }));
const calendarApi = computed(() => get(roomBookingCalendar)?.getApi());
const slotDuration = computed(() => props.slotDuration);
const businessHours = computed(() => {
  if (store.getters["authClient/selectedClinic"].partner == ClinicPartner.Unaffiliated) {
    const setting = get(clinicDaySetting);
    if (_.isEmpty(setting)) return {};
    const dayOfWeekNum = parseInt(get(useDateFormat(get(startDate), "d")), 10) || 0;
    const dayOfWeek = DayOfWeek.getDayOfWeekByNumber(dayOfWeekNum);
    const specialDay = setting.clinic_special_shift_settings_attributes.find(
      (specialDate: any) => specialDate.date === get(startDate)
    );
    const beautifyShiftTime = (start: string, end: string) => ({
      daysOfWeek: specialDay?.day_off || setting[`${dayOfWeek}_off`] ? [] : [dayOfWeekNum],
      startTime: beautifyTime(start),
      endTime: beautifyTime(end),
    });

    if (specialDay)
      return [
        beautifyShiftTime(specialDay.morning_shift_start, specialDay.morning_shift_end),
        beautifyShiftTime(specialDay.afternoon_shift_start, specialDay.afternoon_shift_end),
      ];

    return [
      beautifyShiftTime(setting[`${dayOfWeek}_morning_start`], setting[`${dayOfWeek}_morning_end`]),
      beautifyShiftTime(setting[`${dayOfWeek}_afternoon_start`], setting[`${dayOfWeek}_afternoon_end`]),
    ];
  } else {
    return [{ daysOfWeek: [] }];
  }
});
const currentEventInput = computed(() => {
  const { id: resourceId, extendedProps: resource } = get(currentResource);
  const resExtendedProps = { roomId: resourceId, room: resource };
  const { id, title, start, end, allDay, extendedProps: evtExtendedProps } = get(currentEvent);
  const extendedProps = { ...evtExtendedProps, ...resExtendedProps };

  return { id, title, start, end, allDay, startEditable: true, resourceId, resource, extendedProps };
});

/* Functions: Confirmation Dialog For Updating Event */
const revertCurrentChange = () => {
  undoAction.value();
  set(showUpdateEventConfirmDialog, false);
};
const onUpdateBookingAndNotify = async (notify: boolean) => {
  const event = get(currentEvent).extendedProps;
  const payload = {
    customer_id: event.customerId,
    note_symptom: event.note_symptom,
    customer_name: event.customerName,
    medical_menu_category_id: event.medicalMenuCategoryId,
    medical_menu_id: event.medicalMenuId,
    medical_option_ids: event.medicalOptionIds,
    note: event.note,
    booking_type: event.bookingType,
    start_time: moment(get(currentEvent).start).format("YYYY-MM-DD HH:mm:ss"),
    end_time: moment(get(currentEvent).end).format("YYYY-MM-DD HH:mm:ss"),
    notify,
    staff_id: String(event.staffId).endsWith("fs") ? String(event.staffId).replace(/fs$/, "") : event.staffId,
    room_id: parseInt(get(currentResource).id),
    is_free_space: event.isFreespace,
  } as unknown as ApiBookingSaveReq;

  await BookingServices.saveBooking(
    { ...(await clinicIdParams()), id: event.reservationId },
    payload,
    () => {
      notifySuccessMsg(get(props.toast), "保存成功");
      fetchRemainingSlots();
    },
    errors => {
      notityErrorMsg(get(props.toast), errors.response.data.errors || errors.response.data.error);
      set(showUpdateEventConfirmDialog, false);
      undoAction.value();
    }
  );
  set(showUpdateEventConfirmDialog, false);
  get(currentEvent).remove();
  get(calendarApi).addEvent(get(currentEventInput));
};
/* Functions: Confirmation Dialog For Updating Event */

/* Functions: Header */
const onChangeDate = async (date: IBookingPickedTime) => {
  const previousDate = get(startDate);
  const { start } = date;
  set(pickedDate, { start, end: start });
  await goToDate(previousDate);
};
const onSelectDate = async (date: Date) => {
  const previousDate = get(startDate);
  set(pickedDate, { start: date, end: date });
  await goToDate(previousDate);
};
const goToDate = async (previousDate: string) => {
  get(calendarApi).removeAllEvents();
  get(calendarApi).gotoDate(get(startDate));
  if (previousDate == get(startDate)) get(calendarApi).refetchEvents();
  await fetchResourceData();
};
const onFilter = async (source: { [key: string]: string }, form: HTMLFormElement) => {
  const formData = new FormData(form);
  setStatus(source["status"] ? source["status"] : (formData?.get("status") as string));
  setTerm(source["term"] ? source["term"] : (formData?.get("term") as string));
  await fetchRemainingSlots();
  get(calendarApi).removeAllEvents();
  get(calendarApi).refetchEvents();
};
const onExport = async (event: any) => {
  const button = event.currentTarget;
  button.classList.add("p-disabled");
  const { data } = await BookingServices.exportBookings(await bookingParams());
  window.open(data.value, "_blank");
  button.classList.remove("p-disabled");
};
/* Functions: Header */

/* Functions: General */
const bookingParams = async (): Promise<ApiBookingIndexReq> => {
  return {
    ...(await clinicIdParams()),
    start_time: get(startDate),
    end_time: get(endDate),
    term: get(term),
    status: get(status),
    view_type: BookingViewTypeEnum.Day,
  } as unknown as ApiBookingIndexReq;
};
const clinicIdParams = async () => ({ clinic_id: get(await get(clinicId)) });
const setStatus = (newStatus: string) => set(status, newStatus);
const setTerm = (newTerm: string) => set(term, newTerm);
const beautifyTime = (time: string) => moment(time, "HH:mm:ss").format("HH:mm");
/* Functions: General */

/* Functions: Fullcalendar options */
const events = async () => {
  await get(clinicId);
  return await fetchBookings();
};
const onChangeEvent = async ({ event, oldEvent, revert }: EventChangeArg) => {
  const [currentRes] = event.getResources();
  const [previousRes] = oldEvent.getResources();
  if (
    currentRes.id == previousRes.id &&
    event.end?.getTime() == oldEvent.end?.getTime() &&
    event.start?.getTime() == oldEvent.start?.getTime()
  )
    return;

  // 自由予約の場合は確認ダイアログを表示せずに通知なしで保存
  if (event.extendedProps?.isFreespace) {
    set(currentEvent, event);
    set(previousEvent, oldEvent);
    set(currentResource, currentRes);
    set(previousResource, previousRes);
    set(undoAction, revert);
    onUpdateBookingAndNotify(false); // 通知しない
    return;
  }

  set(currentEvent, event);
  set(previousEvent, oldEvent);
  set(currentResource, currentRes);
  set(previousResource, previousRes);
  set(showUpdateEventConfirmDialog, true);
  set(undoAction, revert);
};
const isClinicUnaffiliated = () => {
  return store.getters["authClient/selectedClinic"].partner == ClinicPartner.Unaffiliated;
};
const eventClassNames = ({
  event: {
    extendedProps: { medicalMenuId, status, bookingType, bookingSource, hotpepperConfirmed },
  },
}: EventContentArg): string => {
  const backgroundClass = backgroundEventClass(status, bookingType, bookingSource, hotpepperConfirmed);
  return `event-medical-${medicalMenuId} event-day ${backgroundClass} border-none`;
};
/**
 * イベントの背景色クラスを取得する（旧イベント情報用）
 *
 * @description
 * 部屋・設備予約カレンダーのイベントカードに適用する背景色クラスを返す。
 * 新しいカードデザイン適用のため、旧デザインの背景色（bg-will-come等）を
 * 使用せず、空文字列を返して背景を透明にする。
 *
 * 実際の背景色の透明化は、グローバルスタイルの`:global(.fc-event)`等で
 * `background-color: transparent !important`を適用することで実現している。
 *
 * @param {string} status - 予約ステータス（will_come, booked, completed等）
 * @param {string} bookingType - 予約タイプ（normal, request等）
 * @param {string} bookingSource - 予約ソース（hotpepper, line, instagram等）
 * @param {string} hotpepperConfirmed - ホットペッパー予約の確認状態
 * @returns {string} 背景色CSSクラス名（空文字列 = 背景色なし）
 *
 * @see グローバルスタイル（行697-704）で背景色を透明化
 * @see BookingStatusColorClass - 旧デザインのステータス別カラークラス定義
 * @see BookingSourceColorClasses - 旧デザインの予約ソース別カラークラス定義
 */
const backgroundEventClass = (
  status: string,
  bookingType: string,
  bookingSource: string,
  hotpepperConfirmed: string
): string => {
  return "";
};
const slotMinTimeMilliseconds = (): number => {
  if (isClinicUnaffiliated()) {
    if (_.isEmpty(get(clinicDaySetting))) return 0;
    const dayOfWeekNum = get(useDateFormat(get(startDate), "d"));
    const dayOfWeek = DayOfWeek.getDayOfWeekByNumber(parseInt(dayOfWeekNum));
    const startTime = get(clinicDaySetting)[`${dayOfWeek}_morning_start`];

    if (startTime) return get(convertTimeToMilliseconds(startTime));
    else return MILLISECONDS_MIN_SLOT_DEFAULT;
  } else {
    return MILLISECONDS_MIN_SLOT_DEFAULT;
  }
};
const slotMaxTimeMilliseconds = (): number => {
  if (store.getters["authClient/selectedClinic"].partner == ClinicPartner.Unaffiliated) {
    if (_.isEmpty(get(clinicDaySetting))) return MILLISECONDS_IN_DAY;
    const dayOfWeekNum = get(useDateFormat(get(startDate), "d"));
    const dayOfWeek = DayOfWeek.getDayOfWeekByNumber(parseInt(dayOfWeekNum));
    const startDayMilliseconds = get(convertTimeToMilliseconds(get(clinicDaySetting)[`${dayOfWeek}_morning_start`]));
    const endDayMilliseconds = get(convertTimeToMilliseconds(get(clinicDaySetting)[`${dayOfWeek}_afternoon_end`]));
    const totalMilliseconds = endDayMilliseconds - startDayMilliseconds;
    const durationMilliseconds = get(convertTimeToMilliseconds(get(slotDuration)));
    const roundingNumber = Math.ceil(totalMilliseconds / durationMilliseconds);
    return totalMilliseconds
      ? roundingNumber * durationMilliseconds + startDayMilliseconds
      : MILLISECONDS_MAX_SLOT_DEFAULT;
  } else {
    return MILLISECONDS_MAX_SLOT_DEFAULT;
  }
};
const convertTimeToMilliseconds = (timeString: string) => {
  if (!timeString) return 0;

  const [hours = "0", minutes = "0", seconds = "0"] = timeString.split(":").map(part => parseInt(part, 10));

  return ((parseInt(hours, 10) * 60 + parseInt(minutes, 10)) * 60 + parseInt(seconds, 10)) * 1000;
};
const onSelect = (event: DateSelectArg) => {
  if (store.getters["authClient/selectedClinic"].partner == ClinicPartner.Unaffiliated) {
    emits("showBookingSideBar", {} as IBooking, BookingActionEnum.new, event);
  }
};
const scrollToCenter = () => {
  if (moment(get(startDate)).isSame(moment(), "day")) {
    const timelineHeader = document.querySelector(".fc-timeline-header");
    const nowIndicatorLine = document.querySelector(".fc-timeline-now-indicator-line");
    const headerScroller = document.querySelector(".fc-scrollgrid thead tr:first-child th:last-child .fc-scroller");

    if (!nowIndicatorLine || !headerScroller || !timelineHeader) return;

    const leftDistance = parseInt(window.getComputedStyle(nowIndicatorLine).left, 0);
    const scrollerWidth = timelineHeader.getBoundingClientRect().width;
    headerScroller.scrollLeft = leftDistance - scrollerWidth / 2.5;
  }
};

const resourceLabelClassNames = (resource: EventSourceFuncArg): string => {
  const {
    resource: {
      _resource: { extendedProps },
    },
  } = resource;
  const { default_room } = extendedProps;
  if (default_room) {
    return "text-red-500";
  } else {
    return "text-black-alpha-90";
  }
};

const calendarOptions = ref({
  schedulerLicenseKey: "CC-Attribution-NonCommercial-NoDerivatives",
  timeZone: "local",
  plugins: [resourceTimelinePlugin, interactionPlugin],
  initialView: "resourceTimelineDay",
  viewClassNames: "view-type-day",
  height: "auto",
  headerToolbar: false,
  events,
  resourceOrder: "-default_room",
  eventClassNames,
  eventChange: onChangeEvent,
  resources: rooms,
  resourceAreaWidth: 200,
  resourceLabelClassNames,
  resourceAreaHeaderContent: "",
  refetchResourcesOnNavigate: true,
  slotMinWidth: 300,
  slotLabelClassNames: "slot-frame-day",
  slotEventOverlap: false,
  slotMinTime: slotMintime,
  slotMaxTime: slotMaxTime,
  slotDuration: slotDuration,
  slotLabelInterval: slotDuration,
  editable: false,
  eventStartEditable: false,
  eventDurationEditable: false,
  eventResourceEditable: false,
  selectable: true,
  select: onSelect,
  nowIndicator: true,
  snapDuration: slotDuration,
  businessHours: businessHours,
  selectConstraint: "businessHours",
} as CalendarOption);

const applyEditableOptions = () => {
  const api = get(roomBookingCalendar)?.getApi();
  if (!api) return;

  const canDrag = store.getters["authClient/selectedClinic"]?.partner == ClinicPartner.Unaffiliated;

  api.setOption("editable", canDrag);
  api.setOption("eventStartEditable", canDrag);
  api.setOption("eventDurationEditable", canDrag);
  api.setOption("eventResourceEditable", canDrag);

  api.removeAllEvents();
  api.refetchEvents();
};

watch(
  () => store.getters["authClient/selectedClinic"]?.partner,
  partner => {
    if (partner === undefined) return;
    applyEditableOptions();
  },
  { immediate: true }
);

const fetchClinicBusinessSetting = async () => {
  if (store.getters["authClient/selectedClinic"].partner == ClinicPartner.Unaffiliated) {
    await ClinicBusinessDaySettingService.getSetting(
      { ...(await clinicIdParams()), date: get(startDate) },
      setting => set(clinicDaySetting, setting),
      () => undefined
    );
  }
  scrollToCenter();
};
const fetchResources = async () => {
  const { data } = await RoomServices.fetchRooms(
    { ...(await clinicIdParams()), include_default: true },
    () => undefined,
    () => undefined,
    () => undefined
  );
  let dataRooms = get(data).rooms;
  if (store.getters["authClient/selectedClinic"].partner != ClinicPartner.Unaffiliated) {
    dataRooms = dataRooms.map(room => ({ ...room, title: room.name }));
    dataRooms = dataRooms.map(room => {
      room = addFreeBookingToResource(room);
      return room;
    });
  }
  set(rooms, dataRooms);
};
const addFreeBookingToResource = room => {
  room["children"] = [{ id: `${room.id}fb`, title: "フリー予約", businessHours: [{ daysOfWeek: [] }] }];

  return room;
};
const fetchRemainingSlots = async () => {
  if (store.getters["authClient/selectedClinic"].partner == ClinicPartner.Unaffiliated) {
    const { data } = await RoomServices.fetchRemainingSlots({ ...(await clinicIdParams()), date: get(startDate) });
    set(remainingSlots, get(data));
  }
};
const fetchBookings = async () => {
  const { data } = await BookingServices.getBookings(await bookingParams());
  const bookings = get(data)?.bookings.map(booking => formatBookings(booking as IBooking));
  return bookings;
};
const formatBookings = (resource: IBooking): IBookingEventInput => {
  let bookingType = resource.booking_type;
  if (resource.booking_request_status != "not_process" && bookingType == "request") {
    bookingType = "normal";
  }
  const extendedProps = {
    reservationId: resource.id,
    staffId: resource.staff_id,
    roomId: resource.room_id,
    customerId: resource.customer_id,
    customerName: resource.customer_name,
    customerNameKana: resource.customer_name_kana,
    customerStatus: resource.customer_status,
    customerStatusDisplayName: resource.customer_status_display_name,
    medicalMenuId: resource.medical_menu_id,
    medicalMenuName: resource.menu_name,
    medicalOptionIds: resource.medical_option_ids,
    bookingTotalAmount: resource.total_amount,
    status: resource.status,
    statusName: resource.status_name,
    note: resource.note,
    note_symptom: resource.note_symptom,
    bookingType,
    bookingSource: resource.booking_source,
    bookingRequestStatus: resource.booking_request_status,
    additionalFees: resource.additional_fees,
    medicalOptionNames: resource.medical_option_names,
    staff: resource.staff,
    room: resource.room,
    specialNotes: resource.special_notes,
    isFreespace: resource.is_free_space,
  } as IBookingEventInputExtendedProps;

  const resourceId = resource.is_free ? `${resource.room_id}fb` : `${resource.room_id}`;

  return {
    id: resource.id,
    resourceId: resourceId,
    start: TimeUtils.toLocalTime(resource.start_time.toString()),
    end: TimeUtils.toLocalTime(resource.end_time.toString()),
    extendedProps,
  } as IBookingEventInput;
};
const fetchResourceData = async () => {
  await fetchRemainingSlots();
  await fetchResources();
  await fetchClinicBusinessSetting();
};
/* Functions: Fullcalendar options */
onBeforeMount(async () => {
  await setClinicId();
  await fetchResourceData();
});

onMounted(() => {
  nextTick(() => {
    applyEditableOptions();
  });
});

expose({
  fetchRemainingSlots,
});

return (_ctx: any,_cache: any) => {
  const _component_VTooltip = _resolveComponent("VTooltip")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["booking-calendar__body", { 'clinic-affiliated': !isClinicUnaffiliated() }])
  }, [
    _createVNode(Header, {
      ref: "headerCalendar",
      pickedDate: pickedDate.value,
      viewType: _unref(BookingViewTypeEnum).Day,
      switchView: false,
      onPrev: onChangeDate,
      onNext: onChangeDate,
      onToday: onChangeDate,
      onFilter: onFilter,
      onExport: onExport,
      onDateSelect: onSelectDate
    }, null, 8, ["pickedDate", "viewType"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(BookingStatusColorOptions), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "d-flex align-items-center mr-3"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([item.colorClass, "mr-2 circle"])
              }, null, 2),
              _createElementVNode("p", _hoisted_4, _toDisplayString(item.name), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_unref(FullCalendar), {
      ref_key: "roomBookingCalendar",
      ref: roomBookingCalendar,
      options: calendarOptions.value
    }, {
      slotLabelContent: _withCtx(({ date }) => [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(moment)(date).format("HH:mm")), 1),
        (_unref(store).getters['authClient/selectedClinic'].partner == _unref(ClinicPartner).Unaffiliated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 空き枠 " + _toDisplayString(remainingSlots.value[_unref(moment)(date).format("HH:mm")] || 0), 1))
          : _createCommentVNode("", true)
      ]),
      eventContent: _withCtx(({ event }) => [
        _createVNode(_component_VTooltip, { distance: 10 }, {
          popper: _withCtx(() => [
            _createVNode(ToolTipEvent, { event: event }, null, 8, ["event"])
          ]),
          default: _withCtx(() => [
            _createVNode(DayEvent, { event: event }, null, 8, ["event"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["options"]),
    _createVNode(_component_Dialog, {
      visible: showUpdateEventConfirmDialog.value,
      "onUpdate:visible": [
        _cache[2] || (_cache[2] = ($event: any) => ((showUpdateEventConfirmDialog).value = $event)),
        revertCurrentChange
      ],
      class: "mx-5 dialog-note border-0",
      modal: "",
      draggable: false,
      style: { width: '550px' }
    }, {
      header: _withCtx(() => [
        _hoisted_7
      ]),
      default: _withCtx(() => [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Button, {
            class: "bg-white border-900 mx-3 w-3",
            label: "キャンセル",
            onClick: revertCurrentChange
          }),
          _createVNode(_component_Button, {
            class: "bg-white border-900 mx-3 w-3",
            label: "通知しない",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onUpdateBookingAndNotify(false)))
          }),
          _createVNode(_component_Button, {
            class: "bg-base-orange mx-3 w-3",
            label: "今すぐ通知",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onUpdateBookingAndNotify(true)))
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 2))
}
}

})